<template>
  <div>
    <div v-for="(survey, s_index) in questions" :key="s_index">
      <b-modal
        v-model="show1"
        :title="'Encuesta de satisfacción - FGA Fondo De Garantías'"
        :hide-header-close="true"
        :close-on-esc="false"
        :close-on-backdrop="false"
        size="lg"
        hide-footer
      >
        <div class="survey-container">
          <section>
            <p>
              En <strong>FGA Fondo De Garantías</strong>, valoramos profundamente tu opinión. Con el objetivo de seguir mejorando nuestro servicio y brindarte siempre una experiencia de calidad, te solicitamos completar esta breve encuesta de satisfacción sobre nuestro equipo comercial. Tu retroalimentación nos permitirá identificar oportunidades de mejora y continuar ofreciendo un servicio que se ajuste a tus necesidades.
            </p>
            <p>
              <strong>Agradecemos tu participación diligenciando esta encuesta a partir del 4 de Noviembre, hasta el viernes, 21 de Noviembre de 2025, evaluando el período comprendido entre septiembre de 2024 y septiembre de 2025.</strong>
            </p>
            <p>
              Como agradecimiento por tu participación en esta encuesta, te obsequiaremos <strong>1.000 puntos Colombia</strong>. Debes tener presente que para poder entregarte el incentivo de los puntos, deberás realizar la creación de usuario en puntos colombia
              <a href="https://www.puntoscolombia.com" target="_blank" rel="noopener">www.puntoscolombia.com</a>
            </p>
            <footer>
              <p>
                El tratamiento de los datos personales se realizará conforme a nuestra política, la cual puede ser consultada en el sitio web
                <a href="https://www.fga.com.co" target="_blank" rel="noopener">www.fga.com.co</a>
                y los derechos como titular podrás ejercerlos a través del correo electrónico
                <a href="mailto:clientes@fga.com.co">clientes@fga.com.co</a>.
              </p>
            </footer>
          </section>
        </div>
        <div class="text-right">
          <b-button
            variant="danger"
            style="margin: 1% 1% 2% 2%"
            @click="show1 = false"
          >Cerrar</b-button>
          <b-button
            variant="primary"
            class="button-carga"
            style="margin: 1% 2% 2% 1%"
            @click="activarEncuesta()"
          >Realizar encuesta</b-button>
        </div>
      </b-modal>
      <b-modal
        v-model="show"
        :title="survey.nombre"
        :hide-header-close="true"
        :close-on-esc="false"
        :close-on-backdrop="false"
        size="lg"
        hide-footer
      >
        <div class="survey-container">
          <div class="position-relative">
            <!-- Overlay de loading para toda la encuesta -->
            <div v-if="isLoading" class="loading-overlay">
              <div class="loading-content">
                <b-spinner class="mb-3"></b-spinner>
                <p class="mb-0">Enviando encuesta...</p>
              </div>
            </div>

            <b-form>
                <div v-for="(g, g_index) in survey.preguntas" :key="g_index" class="mb-5">
                  <div v-if="g.grupo != ''">
                    <h3 class="label-survey mb-3" style="font-weight: 500; font-size: 18px;">
                      {{ g.grupo }}
                      <span v-if="g.preguntas.length == 1 && g.preguntas[0].required" class="text-danger">*</span>
                    </h3>
                  </div>
                  <div v-for="(q, p_index) in g.preguntas" :key="p_index" class="mb-4">
                    <div v-if="q.label != ''">
                      <h5 class="label-survey" style="font-weight: 400;font-size: 14px;">
                        {{ q.label }}
                        <span v-if="q.required" class="text-danger">*</span>
                      </h5>
                    </div>

                    <!-- Campo de texto -->
                    <div v-if="q.tipo === 'text'">
                      <b-form-input
                        v-model="responses[s_index][q['v-model']]"
                        :placeholder="q.placeholder || ''"
                        :maxlength="q.maxLength || 100"
                      />
                    </div>

                    <!-- Campo de matriz de radio -->
                    <div v-if="q.tipo === 'matrix-radio'">
                      <table  style="margin-bottom: 50px;">
                        <thead>
                          <tr>
                            <th></th>
                            <th v-for="(opcion, o_index) in q.options" :key="o_index" class="text-primary" style="font-size: 13px !important; font-weight: 400 !important; height: 40px !important; padding: 10px !important;">
                              {{ opcion }}
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr v-for="(subpregunta, z_index) in q.questions" :key="z_index">
                            <td class="text-left">{{ subpregunta }}</td>
                            <td :colspan="q.options.length">
                              <b-form-radio-group
                                :id="`${g_index}_radio-group-${z_index}`"
                                :name="`${g_index}_question-${z_index}`"
                                v-model="responses[s_index][`${q['v-model'][z_index]}`]"
                                :options="q.options.map(o => ({ text: '', value: o }))"
                                class=" d-flex justify-content-around"
                              ></b-form-radio-group>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- Campo numérico -->
                    <div v-else-if="q.tipo === 'number'">
                      <b-form-input
                        v-model.number="responses[s_index][q['v-model']]"
                        type="number"
                        :placeholder="q.placeholder || ''"
                        :min="q.min"
                        :max="q.max"
                      />
                    </div>

                    <!-- Campo de fecha -->
                    <div v-else-if="q.tipo === 'date'">
                      <b-form-input
                        v-model="responses[s_index][q['v-model']]"
                        type="date"
                      />
                    </div>

                    <!-- Select simple -->
                    <div v-else-if="q.tipo === 'select'">
                      <b-form-select
                        v-model="responses[s_index][q['v-model']]"
                        :options="[{ text: 'Seleccione...', value: null }, ...q.options.map(o => ({ text: o, value: o }))]"
                        :placeholder="q.placeholder || ''"
                      />
                    </div>

                    <!-- Multiselect -->
                    <div v-else-if="q.tipo === 'multiselect'">
                      <b-form-select
                        v-model="responses[s_index][q['v-model']]"
                        :options="q.options.map(o => ({ text: o, value: o }))"
                        multiple
                        :placeholder="q.placeholder || ''"
                      />
                    </div>

                    <!-- Radio buttons -->
                    <div v-else-if="q.tipo === 'radio'">
                      <b-form-radio-group
                        v-model="responses[s_index][q['v-model']]"
                        :options="q.options.map(o => ({ text: o, value: o }))"
                        stacked
                      />
                    </div>

                    <!-- Checkboxes -->
                    <div v-else-if="q.tipo === 'checkbox'">
                      <div v-for="option in q.options" :key="option" class="mb-2">
                        <b-form-checkbox
                          v-model="responses[s_index][q['v-model']]"
                          :value="option"
                        >
                          {{ option }}
                        </b-form-checkbox>
                      </div>
                    </div>

                    <!-- Textarea -->
                    <div v-else-if="q.tipo === 'textarea'">
                      <b-form-textarea
                        v-model="responses[s_index][q['v-model']]"
                        :placeholder="q.placeholder || ''"
                        :maxlength="q.maxLength || 500"
                        :rows="q.rows || 3"
                        max-rows="6"
                      />
                    </div>

                    <div v-if="q.required_message" class="text-danger small mt-1">
                      El campo es obligatorio
                    </div>
                  </div>
                </div>

                <div class="text-right">
                  <b-button
                    variant="secondary"
                    class="button-carga"
                    style="margin: 1% 1% 2% 2%"
                    @click="show = false"
                  >Cerrar</b-button>
                  <b-button
                    variant="primary"
                    class="button-carga"
                    style="margin: 1% 2% 2% 1%"
                    @click="guardarEncuesta(survey.id)"
                  >Enviar</b-button>
                </div>
              </b-form>
          </div>
        </div>
      </b-modal>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      show: false,
      show1: false,
      questions: [],
      responses: [],
      isLoading: false,
      validationErrors: {}
    }
  },
  methods: {
    cargarEncuestas() {
      const surveyData = localStorage.getItem('surveyPopup');
      const parsedData = JSON.parse(surveyData);
      if (!Array.isArray(parsedData) || parsedData.length === 0) {
        return;
      }

      const completedSurveys = Object.keys(localStorage)
          .filter(key => key.startsWith('completedSurveys_'))
          .reduce((acc, key) => {
            acc[key] = JSON.parse(localStorage.getItem(key));
            return acc;
          }, {});

      let encuesta_id = null;
      for (const key in completedSurveys) {
        if(!completedSurveys[key]){
          encuesta_id = key.split('_')[1];
          break;
        }
      }

      if(encuesta_id){
        parsedData.forEach((survey) => {
          if (survey.id == encuesta_id) {
            if (!Array.isArray(survey.preguntas))survey.preguntas = JSON.parse(survey.preguntas);
            this.questions = [survey];
          }
        });
      }else{
        this.questions = [];
      }

    },
    // ValidarResopuestas(sig_encuesta_id) {
    //   let errors = false;
    //   this.validationErrors = {};
    //   let survey = this.questions.find(q => q.id === sig_encuesta_id);
    //   if (!survey) {
    //     return false;
    //   }
    //   survey.preguntas.forEach(q => {
    //     if(q.tipo !== 'matrix-radio'){
    //       if (!(Object.prototype.hasOwnProperty.call(this.responses, q['v-model']) && this.responses[q['v-model']] !== null && this.responses[q['v-model']] !== '') && q.required) {
    //         this.$set(this.validationErrors, q['v-model'], 'El campo es obligatorio');
    //         errors = true;
    //       }
    //     }else{
    //       q['v-model'].forEach(key => {
    //         if (!(Object.prototype.hasOwnProperty.call(this.responses, key) && this.responses[key] !== null && this.responses[key] !== '') && q.required) {
    //           this.$set(this.validationErrors, q['v-model'], 'El campo es obligatorio');
    //           errors = true;
    //         }
    //       });
    //     }
    //   });
    //   return errors;
    // },
    activarEncuesta(){
      this.show1 = false;
      this.show = true;
    },
    ValidarResopuestas(sig_encuesta_id){
      let errors = false;
      let surveyIndex = this.questions.findIndex(q => q.id === sig_encuesta_id);
      let survey = this.questions[surveyIndex];
      if (!survey) {
        return false;
      }

      survey.preguntas.forEach(grupos => {
        grupos.preguntas.forEach(q => {
          q.required_message = false;
        });
      });

      survey.preguntas.forEach(grupos => {
        grupos.preguntas.forEach(q => {
          if (q.required) {
            if(q.tipo == "matrix-radio"){
              q['v-model'].forEach(key => {
                if (!this.responses[surveyIndex][key]) {
                  errors = true;
                  q.required_message = true;
                }
              });
            }else{
              if (!this.responses[surveyIndex][q['v-model']]) {
                errors = true;
                q.required_message = true;
              }
            }
          }
        });
      });
      return errors;
    },
    async guardarEncuesta(sig_encuesta_id) {
      if (this.ValidarResopuestas(sig_encuesta_id)){
        this.$toasted.show(
            "Por favor, complete todas las preguntas obligatorias.",
            {
              theme: "toasted-primary",
              position: "bottom-right",
              duration: 5000,
            }
          );
        return;
      };

      this.isLoading = true;

      try {
        let surveyIndex = this.questions.findIndex(q => q.id === sig_encuesta_id);
        let survey = this.questions[surveyIndex];
        if (!survey) {
          throw new Error('Encuesta no encontrada');
        }
        // // Refactorizada para la nueva estructura de grupos y preguntas
        // const respuestas = survey.preguntas.reduce((acc, grupo) => {
        //   grupo.preguntas.forEach(q => {
        //     if (q.tipo !== 'matrix-radio') {
        //       const key = q['v-model'];
        //       acc[key] = this.responses[key];
        //     } else {
        //       const matrixKey = q['v-model-matrix'];
        //       acc[matrixKey] = {};
        //       q['v-model'].forEach((subKey) => {
        //         acc[matrixKey][subKey] = this.responses[subKey];
        //       });
        //     }
        //   });
        //   return acc;
        // }, {});

        const payload = {
          sig_encuesta_id: sig_encuesta_id,
          respuestas: this.responses[surveyIndex]
        };

        await this.$store.dispatch('save', {
          endpoint: 'portal/encuesta/respuestas',
          params: payload
        });

        localStorage.setItem('completedSurveys_'+sig_encuesta_id, true);

        this.$toasted.show('¡Encuesta enviada exitosamente!', {
          theme: "toasted-primary",
          position: "bottom-right",
          duration: 5000,
        });
      } catch (error) {
        if (error.response && error.response.data && error.response.data.errors) {
          error.response.data.error.forEach(error => {
            this.$toasted.show(error, {
              theme: "toasted-primary",
              position: "bottom-right",
              duration: 5000,
            });
          });

        }
      } finally {
        this.show = false;
        this.isLoading = false;
      }
    },
    loadResponse() {
      // La nueva estructura tiene un arreglo de grupos, cada uno con grupo y preguntas
      this.questions.forEach((survey, s_index) => {
        this.responses[s_index] = {};
        survey.preguntas.forEach((grupo, g_index) => {
          grupo.preguntas.forEach((q, p_index) => {
            if (q.tipo === "matrix-radio") {
              q["v-model"].forEach(key => {
                this.responses[s_index][key] = null;
              });
            } else if (q["v-model"]) {
              this.responses[s_index][q["v-model"]] = null;
            }
          });
        });
      })
    }
  },
  watch: {
    '$route.path': {
      immediate: false,
      async handler(newPath, oldPath) {
        if (oldPath && newPath !== '/login' && newPath !== '/cambio-pass') {
          function sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
          }

          const functionalRoutes = [
            '/',
            '/home',
            '/carga',
            '/informes',
            '/productos',
            '/novedades',
            '/estado-procesos',
            '/mensajes',
            '/descargas',
            '/glosario'
          ];

          const isFunctionalRoute = functionalRoutes.some(route => newPath.startsWith(route));
          
          if (isFunctionalRoute) {
            await this.cargarEncuestas();
            if(this.questions.length == 0){
              await sleep(5000);
              await this.cargarEncuestas();
            }
            this.loadResponse();
            if (this.questions.length > 0) {
              this.show1 = true;
              this.validationErrors = {};
            }
          }
        }
      }
    },
  }
}
</script>

<style scoped>
.survey-container {
  width: 100%;
  height: 100%;
  min-height: 600px;
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
}
.label-survey{
  font-weight: 700;
  font-size: 15px;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(248, 249, 250, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 8px;
}

.loading-content {
  text-align: center;
  color: #6c757d;
}

</style>